export function useNavigationGuard() {
  const navStore = useNavigationStore();
  const { makeGuardResult } = useRouteGuard();

  /**
   * @return GuardResult
   */
  const guardRouteAccess: AccessGuard = ({ to }) => {
    const result = navStore.matchMenuItemByPath(to.path);
    const hasAccess = !result || result.hasAccess;

    if (!hasAccess) {
      devConsole.warn("🚦 guard rule triggered: access denied to route", to.path);
      return makeGuardResult(to, "root");
    }

    return makeGuardResult(to, "continue");
  };

  return {
    name: "navigationGuard",
    guardRouteAccess,
  };
}
